import { Select } from "antd";
import { PermissionVm } from "api/generated/lumen";
import { useSelector } from "app/store";
import { ItemProps } from "models/common";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./PermissionSelect.module.scss";

type PermissionsSelectProps = {
  handleSelectedPermissions: (e: PermissionVm[]) => void;
  selectedPermissions: PermissionVm[];
};

const PermissionSelect = ({
  handleSelectedPermissions,
  selectedPermissions,
  ...props
}: PermissionsSelectProps) => {
  const { t } = useTranslation();
  const { permissions } = useSelector(
    (state) => state.usersAndPermissionsAssign
  );

  const options = useMemo<ItemProps[]>(
    () =>
      (permissions || []).map((permission) => ({
        label: permission.name || "",
        value: permission.name || "",
      })),
    [permissions]
  );

  const handleChangePermissions = (value: (string | undefined | null)[]) => {
    const filteredPermissions = permissions?.filter(
      ({ name }) => name && value.includes(name)
    );
    handleSelectedPermissions(filteredPermissions || []);
  };

  return (
    <Select
      {...props}
      size="large"
      allowClear
      mode="tags"
      value={selectedPermissions.map(({ name }) => name)}
      className={styles.selectWrapper}
      options={options}
      onChange={(e) => handleChangePermissions(e)}
      placeholder={t(
        "rolesAndPermissionsSettings.permissionsSelect.placeholder"
      )}
      maxTagCount="responsive"
    />
  );
};

export default PermissionSelect;
